/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { InjectionToken } from '@angular/core';
import { SysqueElectricalState } from '@hcworkspace/sysque/toolbelt/feature';
import { Observable } from 'rxjs';
import { SystemInfo } from '../system-info';
import { FittingPrioritization } from '../fitting-prioritization-types';
import { FittingPrioritizationReturnCodes } from '../../../../../feature/src/lib/models/fitting-prioritization-return-codes-types';

export interface IFittingPrioritizationFacade {
  closeWindow(): void;
  resizeWindowHeight(height: number): void;
  getState(): SysqueElectricalState;
  getSystems(): Observable<SystemInfo[]>;
  getMainShape(systemName: string): Observable<string>;
  getFittingTypes(systemName: string, shape: string): Observable<string[]>;
  getItemsBySystemAndFittingType(system: string, fittingType: string): Observable<FittingPrioritization[]>;
  reorderFittings(reorderItems: FittingPrioritization[], systemName: string, shape: string): Observable<FittingPrioritizationReturnCodes>;
  updateLocalStorage(key: string, value: any): void
}

export const FITTING_PRIORITIZATION_FACADE_TOKEN = new InjectionToken<IFittingPrioritizationFacade>(
  'FITTING_PRIORITIZATION_FACADE_TOKEN'
);
